import { FC } from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import s from "./Loading.module.scss";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

interface LoadingProps {
    size?: SizeProp;
}

export const Loading: FC<LoadingProps> = (props) => {
    return (
        <div className={s.loading}>
            <FontAwesomeIcon icon={faSpinner} size={props.size} spin />
        </div>
    );
};